const config = {
    useEmulators: !!process.env.REACT_APP_EMULATORS,
    functions: {
        updateInvoices: 'https://updateinvoices-dnu54v6ana-ew.a.run.app',
        finalizeInvoice: 'https://finalizeinvoice-dnu54v6ana-ew.a.run.app',

        initAzureAuth: 'https://azureauth-dnu54v6ana-ew.a.run.app',
        codeAzureAuth: 'https://azureauthcode-dnu54v6ana-ew.a.run.app',

        azureGetCompanies: 'https://azuregetcompanies-dnu54v6ana-ew.a.run.app',
        azureGetCustomers: 'https://azuregetcustomers-dnu54v6ana-ew.a.run.app',
        azureGetItems: 'https://azuregetitems-dnu54v6ana-ew.a.run.app',
    }
}

if (config.useEmulators) {
    config.functions = {
        updateInvoices: 'http://127.0.0.1:5001/logilink-b67ce/europe-west1/updateInvoices',
        finalizeInvoice: 'http://127.0.0.1:5001/logilink-b67ce/europe-west1/finalizeInvoice',

        initAzureAuth: 'http://127.0.0.1:5001/logilink-b67ce/europe-west1/azureAuth',
        codeAzureAuth: 'http://127.0.0.1:5001/logilink-b67ce/europe-west1/azureAuthCode',

        azureGetCompanies: 'http://127.0.0.1:5001/logilink-b67ce/europe-west1/azureGetCompanies',
        azureGetCustomers: 'http://127.0.0.1:5001/logilink-b67ce/europe-west1/azureGetCustomers',
        azureGetItems: 'http://127.0.0.1:5001/logilink-b67ce/europe-west1/azureGetItems',
    }
}

export default config;